export default __webpack_public_path__ + "static/media/diwali.099b1c0b.png";